/**
 * MentorCoaching.AI Design System
 *
 * Complete design system export for consistent, professional UI
 */

// Theme
export { theme, colors, reviewDesk, typography, spacing } from './theme';

// Components
export * from './components';

// Default theme export for convenience
export { default } from './theme';
